import { useAppSelector } from '../data/store';
import Imgix from 'react-imgix';
import AddedCartItemPrices from './added-cart-item-prices';
import ProductPriceFormat from '../../products/product-price/product-price-format';
import React from 'react';
import { sendGAEvent } from '../../../domain/marketing/gtm-provider';
import { addToCartPopupGaAction } from './add-to-cart-popup';

const AddedCartItem = () => {

    const addedCartItem = useAppSelector(store => store.root.addedCartItem);
    const cartData = useAppSelector(store => store.root.cartData);
    const hasDiscount = (cartData?.priceData?.totalDiscountPrice ?? 0) > 0;

    const sendViewCartEvent = () => {
        sendGAEvent(addToCartPopupGaAction, 'View Cart');
    };

    return (
        <>
            {
                addedCartItem &&
                <div className="flex items-center flex-col md:flex-row">

                    <a
                        href={`/cart`}
                        onClick={ sendViewCartEvent }
                        className="text-blue-200 no-underline mb-2 md:hidden w-full text-right">view cart</a>

                    <div className="flex items-center w-full md:w-auto">
                        <a href={ addedCartItem.documentUrlPath } onClick={ () => {
                            sendGAEvent(
                                addToCartPopupGaAction,
                                `Main Image: ${ addedCartItem.skuName }`
                            );
                        }}>
                            <Imgix
                                className="mr-4 md:mr-6 "
                                src={addedCartItem.skuThumb}
                                height={120}
                                htmlAttributes={{
                                    alt: `Image for ${addedCartItem.skuName}`,
                                    loading: 'lazy',
                                }}
                                disableQualityByDPR
                            />
                        </a>

                        <div>
                            <p className="font-bold text-gray-700">
                                <a href={addedCartItem.documentUrlPath} className="no-underline text-gray-700" onClick={() => {
                                    sendGAEvent(
                                        addToCartPopupGaAction,
                                        `Main Name: ${addedCartItem.skuName}`
                                    );
                                }}>
                                    {addedCartItem.skuName}
                                </a>
                            </p>
                            <p className="text-gray-500 text-sm mb-1">Qty: {addedCartItem.skuUnits}</p>
                            <AddedCartItemPrices/>
                        </div>
                    </div>

                    <div className="flex flex-1 md:items-end flex-col mt-4 md:mt-0 md:ml-4 w-full md:w-auto">
                        <a
                            href={`/cart`}
                            onClick={ sendViewCartEvent }
                            className="text-blue-200 no-underline hidden md:block mb-4">view cart</a>

                        {
                            hasDiscount &&
                            <div className="flex items-center justify-between text-green font-bold">
                                <span className="mr-4">Discount:</span>
                                <span className="font-bold">-<ProductPriceFormat
                                    price={cartData?.priceData?.totalDiscountPrice ?? 0}/></span>
                            </div>
                        }

                        <div className={`flex items-center justify-between mb-2 ${ hasDiscount ? '' : 'mt-4 md:mt-0' }`}>
                            <span className="mr-4">Cart Total:</span>
                            <span className="font-bold"><ProductPriceFormat
                                price={cartData?.priceData?.totalPrice ?? 0}/></span>
                        </div>

                        <a
                            href={`/cart`}
                            onClick={ () => {
                                sendGAEvent(addToCartPopupGaAction, 'Checkout');
                            }}
                            className="w-btn w-auto font-normal text-sm py-3 md:py-2 mt-2 md:mt-0">Proceed to Checkout</a>
                    </div>
                </div>
            }
        </>
    )
};

export default AddedCartItem;